import { useAuth } from 'context/auth';
import useSWR, { type Key, type BareFetcher, type SWRConfiguration } from 'swr';

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- generic defaults match SWR's own API; callers specify types when needed
export function useSWRWhenAuthed<Data = any, Error = any>(
  key: Key,
  fetcher?: BareFetcher<Data> | null,
  config?: SWRConfiguration<Data, Error, BareFetcher<Data>>
) {
  const { isLoggedIn } = useAuth();
  return useSWR<Data, Error>(isLoggedIn ? key : null, fetcher ?? null, config);
}
